import MobileViewGenerator from '../../../MobileViewGenerator/MobileViewGenerator';
import SimpleListItem from '../../../MobileViewGenerator/subdirectives/list/SimpleList/SimpleList';
import SimpleEditItem from '../../../MobileViewGenerator/subdirectives/edit/SimpleEdit/SimpleEdit';

export default MobileViewGenerator(SimpleListItem, SimpleEditItem);
